import { ILocalization, ILocalizationToken } from '../../../../../application/language/ILocalization';
import { inject } from '../../../../../common/container/inject';
import { injectEntityList } from '../../../../../common/store/base/injectEntityList';
import { injectPrimitive } from '../../../../../common/store/base/injectPrimitive';
import { IEntityListStore } from '../../../../../common/store/interface/IEntityListStore';
import { IPrimitiveStore } from '../../../../../common/store/interface/IPrimitiveStore';
import { IProjectLearningReportArg } from '../../../../../service/report/interface/IProjectLearningReportArg';
import { IMetricsDomain } from './IMetricsDomain';
import { IMetricCard, mapToMetricsSectionData } from './MetricsSectionDTO';
import { IMetricsSectionUI } from './IMetricsSectionUI';

export class MetricsSectionUI implements IMetricsSectionUI {
  private alreadyBooted: IPrimitiveStore<boolean>;
  isFetching: IPrimitiveStore<boolean>;
  data: IEntityListStore<IMetricCard>;

  constructor(
    private metricsDomain: IMetricsDomain,
    private reportArg: IProjectLearningReportArg = {},
    private i18n: ILocalization = inject<ILocalization>(ILocalizationToken),
    private averageProgressLabelKey?: string,
  ) {
    this.alreadyBooted = injectPrimitive(false);
    this.isFetching = injectPrimitive(false);
    this.data = injectEntityList<IMetricCard>([]);
  }

  boot = async () => {
    if (this.alreadyBooted.value) return;
    this.isFetching.setValue(true);
    try {
      const data = await this.metricsDomain.getMetricsData(this.reportArg);
      this.data.setList(mapToMetricsSectionData(data, this.i18n, this.averageProgressLabelKey));
    } finally {
      this.alreadyBooted.setValue(true);
      this.isFetching.setValue(false);
    }
  };
}
